import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="wrapper">
          <div className="footer-left">
            <div className="logotype horizontal">
              <img
                src="/assets/logo-only.svg"
                alt=""
                loading="lazy"
                width="265"
                height="198"
                draggable="false"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 388 50"
                fill="currentColor"
                stroke="none"
                style={{ marginTop: '8px' }}
              >
                <use href="/assets/foot-text.svg"></use>
              </svg>
            </div>
            <p>© 2025. All rights reserved.</p>
          </div>
          <div className="footer-right">
            <nav className="nav">
              <ul>
                <li>
                  <a
                    href="/dashboard"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Buy AIFL
                  </a>
                </li>
                <li>
                  <a
                    href="/docs"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="/staking">Staking</a>
                </li>
              </ul>
            </nav>
            <ul className="socials">
              <li>
                <a
                  href="https://x.com/aiflownetwork"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X - Twitter"
                  title="X - Twitter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--ri"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M10.488 14.651L15.25 21h7l-7.858-10.478L20.93 3h-2.65l-5.117 5.886L8.75 3h-7l7.51 10.015L2.32 21h2.65zM16.25 19L5.75 5h2l10.5 14z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/AIflowNetwork"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Telegram"
                  title="Telegram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--ph"
                    width="1em"
                    height="1em"
                    viewBox="0 0 256 256"
                  >
                    <path
                      fill="currentColor"
                      d="M228.88 26.19a9 9 0 0 0-9.16-1.57L17.06 103.93a14.22 14.22 0 0 0 2.43 27.21L72 141.45V200a15.92 15.92 0 0 0 10 14.83a15.91 15.91 0 0 0 17.51-3.73l25.32-26.26L165 220a15.88 15.88 0 0 0 10.51 4a16.3 16.3 0 0 0 5-.79a15.85 15.85 0 0 0 10.67-11.63L231.77 35a9 9 0 0 0-2.89-8.81m-61.14 36l-89.59 64.16l-49.6-9.73ZM88 200v-47.48l24.79 21.74Zm87.53 8l-82.68-72.5l119-85.29Z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/AiFLow"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                  title="GitHub"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--ri"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M5.884 18.653c-.3-.2-.558-.455-.86-.816a51 51 0 0 1-.466-.579c-.463-.575-.755-.841-1.056-.95a1 1 0 1 1 .675-1.882c.752.27 1.261.735 1.947 1.588c-.094-.117.34.427.433.539c.19.227.33.365.44.438c.204.137.588.196 1.15.14c.024-.382.094-.753.202-1.095c-2.968-.726-4.648-2.64-4.648-6.396c0-1.24.37-2.356 1.058-3.292c-.218-.894-.185-1.975.302-3.192a1 1 0 0 1 .63-.582c.081-.024.127-.035.208-.047c.803-.124 1.937.17 3.415 1.096a11.7 11.7 0 0 1 2.687-.308c.912 0 1.819.104 2.684.308c1.477-.933 2.614-1.227 3.422-1.096q.128.02.218.05a1 1 0 0 1 .616.58c.487 1.216.52 2.296.302 3.19c.691.936 1.058 2.045 1.058 3.293c0 3.757-1.674 5.665-4.642 6.392c.125.415.19.878.19 1.38c0 .665-.002 1.299-.007 2.01c0 .19-.002.394-.005.706a1 1 0 0 1-.018 1.958c-1.14.227-1.984-.532-1.984-1.525l.002-.447l.005-.705c.005-.707.008-1.337.008-1.997c0-.697-.184-1.152-.426-1.361c-.661-.57-.326-1.654.541-1.751c2.966-.333 4.336-1.482 4.336-4.66c0-.955-.312-1.744-.913-2.404A1 1 0 0 1 17.2 6.19c.166-.414.236-.957.095-1.614l-.01.003c-.491.139-1.11.44-1.858.949a1 1 0 0 1-.833.135a9.6 9.6 0 0 0-2.592-.349c-.89 0-1.772.118-2.592.35a1 1 0 0 1-.829-.134c-.753-.507-1.374-.807-1.87-.947c-.143.653-.072 1.194.093 1.607a1 1 0 0 1-.189 1.045c-.597.655-.913 1.458-.913 2.404c0 3.172 1.371 4.328 4.322 4.66c.865.097 1.202 1.177.545 1.748c-.193.168-.43.732-.43 1.364v3.15c0 .985-.834 1.725-1.96 1.528a1 1 0 0 1-.04-1.962v-.99c-.91.061-1.661-.088-2.254-.485"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/rpPTF3DRFk"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Discord"
                  title="Discord"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--ri"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M8.52 13.846c-1.04 0-1.888-.945-1.888-2.101s.827-2.102 1.889-2.102c1.05 0 1.91.945 1.889 2.102c0 1.156-.839 2.1-1.89 2.1m6.974 0c-1.04 0-1.89-.945-1.89-2.101s.829-2.102 1.89-2.102c1.05 0 1.91.945 1.89 2.102c0 1.156-.829 2.1-1.89 2.1m-5.369-9.523l-.308-.563l-.634.106a16.4 16.4 0 0 0-4.158 1.28l-.228.105l-.142.21c-2.613 3.853-3.33 7.648-2.975 11.375l.039.407l.33.24a16.9 16.9 0 0 0 5.078 2.543l.79.242L9.03 17.55c1.91.472 4.03.472 5.939 0l1.107 2.717l.79-.242a16.8 16.8 0 0 0 5.08-2.545l.327-.238l.04-.402c.436-4.32-.697-8.083-2.958-11.384l-.142-.208l-.228-.104a16.6 16.6 0 0 0-4.154-1.28l-.618-.103l-.314.542c-.088.15-.177.32-.263.493a16 16 0 0 0-3.263 0c-.085-.17-.17-.333-.248-.474M6.715 16.61c.197.114.405.226.61.328l-.449 1.096a15 15 0 0 1-3.428-1.778c-.225-3.138.413-6.305 2.564-9.57a14.6 14.6 0 0 1 2.824-.913c.06.125.116.248.162.356l.273.643l.692-.101a14.1 14.1 0 0 1 4.09 0l.69.1l.272-.642c.047-.112.102-.234.16-.356c.977.21 1.923.52 2.828.915c1.875 2.82 2.821 5.966 2.546 9.567a15 15 0 0 1-3.43 1.779l-.445-1.095c.206-.102.414-.214.613-.329c.49-.282 1.017-.634 1.353-.97l-1.28-1.28c-.163.164-.523.42-.977.682c-.444.256-.885.463-1.167.556c-2.003.663-4.428.663-6.432 0c-.281-.093-.722-.3-1.166-.556c-.454-.261-.814-.518-.978-.682l-1.28 1.28c.337.336.864.688 1.354.97"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://coinmarketcap.com/currencies/ai-flow/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="CoinMarketCap"
                  title="CoinMarketCap"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--simple-icons"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M20.738 14.341c-.419.265-.912.298-1.286.087c-.476-.27-.738-.898-.738-1.774v-2.618c0-1.264-.5-2.164-1.336-2.407c-1.416-.413-2.482 1.32-2.882 1.972l-2.498 4.05v-4.95c-.028-1.14-.398-1.821-1.1-2.027c-.466-.135-1.161-.081-1.837.953l-5.597 8.987A9.9 9.9 0 0 1 2.326 12c0-5.414 4.339-9.818 9.672-9.818c5.332 0 9.67 4.404 9.67 9.818c.004.018.002.034.003.053c.05 1.049-.29 1.883-.933 2.29zm3.08-2.34l-.001-.055C23.787 5.353 18.497 0 11.997 0C5.48 0 .177 5.383.177 12c0 6.616 5.303 12 11.82 12c2.991 0 5.846-1.137 8.037-3.2c.435-.41.46-1.1.057-1.541a1.064 1.064 0 0 0-1.519-.059a9.56 9.56 0 0 1-6.574 2.618c-2.856 0-5.425-1.263-7.197-3.268l5.048-8.105v3.737c0 1.794.696 2.374 1.28 2.544s1.476.054 2.413-1.468c.998-1.614 2.025-3.297 3.023-4.88v2.276c0 1.678.672 3.02 1.843 3.68c1.056.597 2.384.543 3.465-.14c1.312-.828 2.018-2.354 1.944-4.193z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.dextools.io/app/fr/ether/pair-explorer/0x3afbae812f3c29b5926504250888415a01aac57f"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Dextools"
                  title="Dextools"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--simple-icons"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.43753 1.35709C8.06753 2.10186 6.94669 2.73209 6.94692 2.75773C6.94753 2.82389 10.235 4.56135 10.3516 4.55712C10.4047 4.55526 10.7898 4.37029 11.2072 4.14613L11.9664 3.73863L12.7955 4.18339L13.6246 4.62823L14.9824 3.99153C17.0283 3.03211 17.2408 2.92697 17.2075 2.89165C17.1633 2.84479 16.4294 2.43338 14.4385 1.33954C13.4764 0.810875 12.5425 0.292535 12.3632 0.18765C12.184 0.0827638 12.0128 -0.0016099 11.9829 2.33167e-05C11.953 0.00165654 10.8076 0.612342 9.43753 1.35709ZM3.42873 4.60432L2.00257 5.37309V8.7471C2.00257 10.6028 2.0213 12.1211 2.04427 12.1211C2.06716 12.1211 2.76883 11.8037 3.6035 11.4157L5.12109 10.7103V7.15388L5.86268 7.57553C6.43414 7.90015 7.00594 8.2241 7.57809 8.5474L8.55188 9.09763L8.9852 8.89315C9.25696 8.7647 9.52817 8.635 9.79883 8.50405C10.008 8.40241 10.5214 8.16108 10.9397 7.96767C11.3581 7.77417 11.7453 7.5796 11.8002 7.53525C11.8732 7.47634 10.9837 6.9634 8.51043 5.63795C6.6461 4.63883 5.06093 3.82455 4.98783 3.82845C4.91472 3.83236 4.21313 4.18145 3.42873 4.60432ZM17.4645 4.8202C16.4932 5.27781 15.6978 5.6705 15.6969 5.6929C15.6961 5.71526 16.2254 6.04376 16.8734 6.42278C17.5213 6.80188 18.0514 7.13232 18.0514 7.1572C18.0514 7.18203 17.4781 7.47194 16.7774 7.80158C16.0767 8.13113 14.3054 8.96589 12.8413 9.65663L7.93533 11.9709C6.70125 12.5531 5.58886 13.0778 5.46337 13.1372C2.94268 14.328 2.24984 14.6584 2.15469 14.7152C2.05902 14.7723 2.03735 15.104 2.02032 16.7692L2 18.7552L3.27533 19.4333L4.55064 20.1114L6.31905 19.2785C7.2917 18.8205 8.08745 18.4217 8.08745 18.3923C8.08745 18.363 7.90772 18.2408 7.68814 18.1206C7.46846 18.0004 7.01499 17.7344 6.68032 17.5292C6.34568 17.3241 6.01199 17.1359 5.93873 17.1109C5.86549 17.086 5.80663 17.0425 5.80783 17.0141C5.80905 16.9858 6.58777 16.5997 7.53822 16.1562C9.3843 15.2948 10.7971 14.6309 13.8301 13.1996C15.1863 12.5596 16.5427 11.9201 17.8993 11.2809C19.0916 10.7193 20.4778 10.0634 20.9798 9.82336L21.8925 9.3869L21.9128 7.37829L21.9332 5.36977L20.6397 4.6769C19.9283 4.29586 19.3201 3.98502 19.2883 3.98616C19.2564 3.98721 18.4357 4.36249 17.4645 4.8202ZM21.546 12.0665C21.3554 12.1637 20.9789 12.3456 20.7093 12.4707C20.4398 12.5959 19.9283 12.8367 19.5727 13.0061L18.9261 13.3138L18.9114 15.0772C18.9032 16.047 18.869 16.8362 18.8353 16.8311C18.7588 16.8192 17.5471 16.1707 16.329 15.4895C15.4499 14.998 15.3947 14.9785 15.1881 15.0852C15.0687 15.147 14.3549 15.4811 13.6019 15.8278C12.8489 16.1744 12.2082 16.4807 12.1781 16.5085C12.148 16.5361 13.6636 17.3934 15.546 18.4135L18.9685 20.2682L20.4306 19.4789C21.2346 19.0449 21.9183 18.649 21.9498 18.5992C22.0207 18.4872 22.0146 11.8745 21.9436 11.8834C21.9156 11.8869 21.7366 11.9693 21.546 12.0665ZM13.4498 19.8282C13.1962 19.942 12.9426 20.0559 12.6892 20.17C11.9237 20.5156 12.0737 20.5271 11.1631 20.054C10.5566 19.7389 10.2952 19.6417 10.1817 19.6889C10.0966 19.7243 9.36406 20.0682 8.55371 20.4532C7.74342 20.8381 7.05234 21.1531 7.01796 21.1531C6.67799 21.1531 7.24318 21.5055 9.42417 22.6536L11.9819 24L13.0581 23.4455C13.65 23.1406 14.8439 22.5299 15.7112 22.0885C16.5784 21.6469 17.2773 21.2743 17.2642 21.2602C17.251 21.2462 16.5244 20.8568 15.6493 20.3948L14.0583 19.555L13.4498 19.8282Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
